import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Typography,
  Button,
  FormControl,
  TextField,
  InputAdornment,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Autocomplete from '@material-ui/lab/Autocomplete';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useStyles } from './Styles';

const BatchGenealogy = () => {
  const classes = useStyles();
  const history = useHistory();
  const [selectedMaterialCode, setSelectedMaterialCode] = useState('');
  const [selectedBatchNumber, setSelectedBatchNumber] = useState('');
  const [showReport, setShowReport] = useState(false);

  const reportData = {
    cmoName: 'Sai Life Sciences',
    plantID: 'L-717',
    productCode: '71717-1',
    productDescription: 'Actazosin Step 3',
    batchSize: '737.5',
    uom: 'KG',
    batchStatus: 'Completed',
  };

  const stagesData = [
    {
      stage: 'Stage A',
      chemicalNumber: 'BMS-98640-05',
      consumedBatches: [
        {
          materialCode: '170891-1',
          description: 'Sodium Penthalate',
          batchNumber: '9866',
          qty: '524',
          uom: 'KG',
        },
        {
          materialCode: '68263',
          description: 'Carbon Diimidazole',
          batchNumber: '9863',
          qty: '250',
          uom: 'KG',
        },
      ],
      producedBatches: [
        {
          materialCode: '71715-1',
          description: 'Actazosin Step 1',
          batchNumber: '400682',
          qty: '736',
          uom: 'KG',
          isCMO: true,
        },
      ],
    },
    {
      stage: 'Stage B',
      chemicalNumber: 'BMS-98640-04',
      consumedBatches: [
        {
          materialCode: '64119-1',
          description: 'Caffeine Monohydrate',
          batchNumber: '9851',
          qty: '311.62',
          uom: 'KG',
        },
        {
          materialCode: '783-1',
          description: 'Hydrogen',
          batchNumber: '9872',
          qty: '28.0',
          uom: 'KG',
        },
      ],
      producedBatches: [
        {
          materialCode: '71716-1',
          description: 'Actazosin Step 2',
          batchNumber: '400683',
          qty: '736.5',
          uom: 'KG',
          isCMO: true,
        },
      ],
    },
    {
      stage: 'Stage C',
      chemicalNumber: 'BMS-98640-03',
      consumedBatches: [
        {
          materialCode: '71715-1',
          description: 'Actazosin Step 1',
          batchNumber: '9991',
          qty: '742.0',
          uom: 'KG',
        },
        {
          materialCode: '71716-1',
          description: 'Actazosin Step 2',
          batchNumber: '9992',
          qty: '736.5',
          uom: 'KG',
        },
      ],
      producedBatches: [
        {
          materialCode: '71717-1',
          description: 'Actazosin Step 3',
          batchNumber: '400684',
          qty: '737.5',
          uom: 'KG',
          isSponsor: true,
        },
      ],
    },
  ];

  const materialCodes = [
    '23938-5-5462310-A',
    '23938-5-5462310-B',
    '23938-5-5462310-C',
    'Material Code 1',
    'Material Code 2',
  ];

  const batchNumbers = [
    'TYR12345 / 400682',
    'TYR12345 / 400683',
    'TYR12345 / 400684',
    'TYR12344 / 400771',
    'TYR12344 / 400772',
  ];

  const handleBack = () => {
    history.goBack();
  };

  const handleViewReport = () => {
    if (selectedMaterialCode && selectedBatchNumber) {
      setShowReport(true);
    }
  };

  const handleDownloadReport = () => {
    console.log('Download Report');
  };

  return (
    <div className={classes.container}>
      <div className={classes.backButton} onClick={handleBack}>
        <ChevronLeftIcon />
        <Typography variant="body1">Back</Typography>
      </div>

      <Typography className={classes.instructionText}>
        Please select the Material Code and Batch Number to view the report:
      </Typography>

      <div className={classes.formContainer}>
        <FormControl className={classes.formControl}>
          <Typography className={classes.label}>
            Select Material Code<span className={classes.required}>*</span>
          </Typography>
          <Autocomplete
            options={materialCodes}
            value={selectedMaterialCode}
            onChange={(event, newValue) => setSelectedMaterialCode(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Select Material Code..."
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </FormControl>

        <FormControl className={classes.formControl}>
          <Typography className={classes.label}>
            Select Batch Number<span className={classes.required}>*</span>
          </Typography>
          <Autocomplete
            options={batchNumbers}
            value={selectedBatchNumber}
            onChange={(event, newValue) => setSelectedBatchNumber(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Select Batch Number..."
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </FormControl>

        <Button
          variant="contained"
          className={classes.viewReportButton}
          onClick={handleViewReport}
          disabled={!selectedMaterialCode || !selectedBatchNumber}
        >
          View Report
        </Button>

        {showReport && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<GetAppIcon />}
            className={classes.downloadButton}
            onClick={handleDownloadReport}
          >
            Download Report
          </Button>
        )}
      </div>

      {showReport && (
        <>
          <Typography className={classes.reportTitle}>
            Genealogy Report
          </Typography>

          <Box className={classes.summaryContainer}>
            <Box className={classes.summaryTableWrapper}>
              <TableContainer component={Paper} style={{ boxShadow: 'none', backgroundColor: 'transparent' }}>
                <Table className={classes.summaryTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.summaryHeader}>CMO Name</TableCell>
                      <TableCell className={classes.summaryHeader}>Plant ID</TableCell>
                      <TableCell className={classes.summaryHeader}>Product Code</TableCell>
                      <TableCell className={classes.summaryHeader}>Product Description</TableCell>
                      <TableCell className={classes.summaryHeader}>Batch Size</TableCell>
                      <TableCell className={classes.summaryHeader}>UOM</TableCell>
                      <TableCell className={classes.summaryHeader}>Batch Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow className={classes.summaryRow}>
                      <TableCell className={classes.summaryCell}>{reportData.cmoName}</TableCell>
                      <TableCell className={classes.summaryCell}>{reportData.plantID}</TableCell>
                      <TableCell className={classes.summaryCell}>{reportData.productCode}</TableCell>
                      <TableCell className={classes.summaryCell}>{reportData.productDescription}</TableCell>
                  <TableCell className={classes.summaryCell}>{reportData.batchSize}</TableCell>
                  <TableCell className={classes.summaryCell}>{reportData.uom}</TableCell>
                  <TableCell className={classes.summaryCell}>
                    <Button className={classes.statusButton}>
                      {reportData.batchStatus}
                    </Button>
                  </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box className={classes.legendContainer}>
              <Box className={classes.legendItem}>
                <Box className={`${classes.legendSquare} ${classes.legendCMO}`} />
                <Typography>CMO Batches</Typography>
              </Box>
              <Box className={classes.legendItem}>
                <Box className={`${classes.legendSquare} ${classes.legendSponsor}`} />
                <Typography>Sponsor Batches</Typography>
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className={classes.unifiedTable}>
            <Table>
              <TableHead>
                <TableRow className={classes.mainHeaderRow}>
                  <TableCell className={classes.stageHeaderCell} rowSpan={2}>
                    CMO Stage (Chemical Number)
                  </TableCell>
                  <TableCell className={classes.stageHeaderCell} colSpan={4}>
                    Consumed Batches
                  </TableCell>
                  <TableCell className={classes.stageHeaderCell} colSpan={4}>
                    Produced Batches
                  </TableCell>
                </TableRow>
                <TableRow className={classes.mainHeaderRow}>
                  <TableCell className={classes.stageHeaderCell}>Material Code / Description</TableCell>
                  <TableCell className={classes.stageHeaderCell}>Batch Number</TableCell>
                  <TableCell className={classes.stageHeaderCell}>Qty</TableCell>
                  <TableCell className={classes.stageHeaderCell}>UOM</TableCell>
                  <TableCell className={classes.stageHeaderCell}>Material Code / Description</TableCell>
                  <TableCell className={classes.stageHeaderCell}>Batch Number</TableCell>
                  <TableCell className={classes.stageHeaderCell}>Qty</TableCell>
                  <TableCell className={classes.stageHeaderCell}>UOM</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stagesData.map((stage, stageIndex) => {
                  const maxRows = Math.max(
                    stage.consumedBatches.length,
                    stage.producedBatches.length
                  );
                  const isLastStage = stageIndex === stagesData.length - 1;

                  const hasMultipleConsumedBatches = stage.consumedBatches.length > 1;
                  const hasMultipleProducedBatches = stage.producedBatches.length > 1;
                  const shouldCenterProducedBatch = hasMultipleConsumedBatches && !hasMultipleProducedBatches;

                  return Array.from({ length: maxRows }).map((_, rowIndex) => {
                    const consumed = stage.consumedBatches[rowIndex];
                    const produced = stage.producedBatches[rowIndex];
                    const isLastRowOfTable = isLastStage && rowIndex === maxRows - 1;

                    return (
                      <TableRow 
                        key={`${stageIndex}-${rowIndex}`}
                        className={isLastRowOfTable ? classes.tableRow : ''}
                      >
                        {rowIndex === 0 && (
                          <TableCell
                            className={classes.stageCell}
                            rowSpan={maxRows}
                          >
                            {`${stage.stage} (${stage.chemicalNumber})`}
                          </TableCell>
                        )}
                        {/* Consumed side */}
                        <TableCell className={classes.consumedCell}>
                          {consumed
                            ? `${consumed.materialCode} / ${consumed.description}`
                            : ""}
                        </TableCell>
                        <TableCell className={classes.consumedCell}>
                          {consumed?.batchNumber || ""}
                        </TableCell>
                        <TableCell className={classes.consumedCell}>
                          {consumed?.qty || ""}
                        </TableCell>
                        <TableCell className={classes.consumedCell}>
                          {consumed?.uom || ""}
                        </TableCell>
                        {/* Produced side - center with rowSpan if multiple consumed batches but single produced batch */}
                        {shouldCenterProducedBatch ? (
                          rowIndex === 0 && (
                            <>
                              <TableCell 
                                className={classes.dataCell}
                                rowSpan={maxRows}
                                style={{ verticalAlign: 'middle' }}
                              >
                                {produced ? (
                                  <span
                                    className={
                                      produced.isCMO
                                        ? classes.cmoText
                                        : produced.isSponsor
                                        ? classes.sponsorText
                                        : ""
                                    }
                                  >
                                    {produced.materialCode} / {produced.description}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                              <TableCell 
                                className={classes.dataCell}
                                rowSpan={maxRows}
                                style={{ verticalAlign: 'middle' }}
                              >
                                {produced?.batchNumber || ""}
                              </TableCell>
                              <TableCell 
                                className={classes.dataCell}
                                rowSpan={maxRows}
                                style={{ verticalAlign: 'middle' }}
                              >
                                {produced?.qty || ""}
                              </TableCell>
                              <TableCell 
                                className={classes.dataCell}
                                rowSpan={maxRows}
                                style={{ verticalAlign: 'middle' }}
                              >
                                {produced?.uom || ""}
                              </TableCell>
                            </>
                          )
                        ) : (
                          <>
                            <TableCell className={classes.dataCell}>
                              {produced ? (
                                <span
                                  className={
                                    produced.isCMO
                                      ? classes.cmoText
                                      : produced.isSponsor
                                      ? classes.sponsorText
                                      : ""
                                  }
                                >
                                  {produced.materialCode} / {produced.description}
                                </span>
                              ) : (
                                ""
                              )}
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                              {produced?.batchNumber || ""}
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                              {produced?.qty || ""}
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                              {produced?.uom || ""}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    );
                  });
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </div>
  );
};

export default BatchGenealogy;


